import React from 'react'
import config from '../../config'
import SidebarMenuLink from './SidebarMenuLink'

const SidebarMenu = ({menuItems, menuClassName, itemClassName}) => {
    if(!menuItems) {
        return ''
    }

    const routes = config.routes
    const menuOrder = config.menuOrder

    const internRoutes = _.reject(menuItems, (item) => {
        return item == 'matomo' || item == 'google_analytics'
    })

    const menuLinks = menuOrder.map((itemID, index) => {
        if(internRoutes.includes(itemID)) {
            const item = routes[itemID]
            
            return <SidebarMenuLink
                key={index}
                linkID={itemID}
                path={item.path}
                name={item.name}
                transId={item.transId}
                itemClassName={itemClassName}
            /> 
        }
    })

    // const menuLinks = internRoutes.map((itemID, index) => {
    //     const item = routes[itemID]

    //     return <SidebarMenuLink
    //         key={index}
    //         linkID={itemID}
    //         path={item.path}
    //         name={item.name}
    //         itemClassName={itemClassName}
    //     /> 
    // })
    
    if(_.contains(menuItems, 'matomo')) {
        menuLinks.push(
            <li key="matomo" className="matomo">
                <a href="https://analytics.planetmutlu.com" target="_blank">
                    <span className="navigation-items">MATOMO</span>
                </a>
            </li> 
        )
    }

    if(_.contains(menuItems, 'google_analytics')) {
        menuLinks.push(
            <li key="matomo" className="matomo">
                <a href="https://www.google.com/analytics/web/?hl=de" target="_blank">
                    <span className="navigation-items">GOOGLE ANALYTICS</span>
                </a>
            </li> 
        )
    }
    
    

    return (
        <nav className={menuClassName}>
            <ul>
                {menuLinks}
            </ul>
        </nav>
    )
}

export default SidebarMenu